import { defineAsyncComponent } from 'vue'
import { tabOutlineChartLine } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { FeatureConfig } from 'src/models'
import { hasInvalidDigitalTwins } from 'src/utils/type-checks'

const featureConfig: FeatureConfig = {
  drawer: {
    drawerComponent: defineAsyncComponent(() => import('./TimeSeriesFeatureDrawerMain.vue')),
    width: 700,
    icon: tabOutlineChartLine,
    label: 'Time Series',
    hide: hasInvalidDigitalTwins
  }
}
export default featureConfig
